var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"justify-content-center"},[_c('div',{staticClass:"col-md-4"},[_c('welcome')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }